var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-layout',{attrs:{"column":"","wrap":"","justify-center":"","align-start":""}},[_c('v-flex',{staticClass:"mb-7",staticStyle:{"width":"100%"}},[_c('vandarTable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }